import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import {
  CircularProgress, Tooltip, Select, MenuItem, FormControl,
  InputAdornment, TextField, TableContainer, Table, TableHead, TableBody, Paper,
  TablePagination
} from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { ContextSession } from "../../../services/ContextSession";
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { useMediaQuery } from '@mui/material';

async function getSolicitudes(accesos, ip, id) {
 // console.log("EL ID ES:::::::::: ", id);
  let url = "https://be.injupemp.gob.hn:8443/api/resumenOficial/";
  //let url = "http://172.20.7.10:8082/api/resumenOficial/"; //ip pruebas
  
  // Crea un FormData y añade el id
  const formData = new FormData();
  formData.append('Oficial_id', id);

  let response = await fetch(url, {
    method: 'POST',
    body: formData,
  });

  if (response.ok) {
    return response.json(); // Devuelve la respuesta como JSON
  } else {
    throw new Error('Error en la solicitud');
  }
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#19438C',
    color: 'white',
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: 'none',
    borderLeft: 'none',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    backgroundColor: '#C1C1C1',
  },
}));

const actionButtonsCSS = `
    .action-buttons {
        display: flex;
        gap: 20px;
    }

    .action-buttons a:hover {
        opacity: 0.7;
        cursor: pointer;
    }
`;

function EmpleadosDash() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const [loanType, setLoanType] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [filas, setFilas] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        let token = sessi.sessionData.token;
        const data = await getSolicitudes(token, sessi.ip, sessi.sessionData.id);
       // console.log(data);
        // Ordenar los datos por estado y fecha
        const sortedData = data.sort((a, b) => {
          // Determina el estado de las solicitudes
          const statusA = a.aprobado === 1 ? 'Aprobado' :
            a.aprobado === 2 ? 'Aprobado Sujeto A Cambios' :
              a.aprobado === 3 ? 'Rechazado' : 'Sin Revisar';
          const statusB = b.aprobado === 1 ? 'Aprobado' :
            b.aprobado === 2 ? 'Aprobado Sujeto A Cambios' :
              b.aprobado === 3 ? 'Rechazado' : 'Sin Revisar';

          // Primero compara el estado, "Sin Revisar" debe ir antes
          if (statusA === 'Sin Revisar' && statusB !== 'Sin Revisar') return -1;
          if (statusB === 'Sin Revisar' && statusA !== 'Sin Revisar') return 1;

          // Luego compara las fechas en orden ascendente
          return new Date(a.FechaSolicitud) - new Date(b.FechaSolicitud);
        });

        setFilas(sortedData); // Aquí se asume que `data` es un array de objetos
        setLoading(false);
      } catch (error) {
        console.error('Error al obtener datos:', error);
        setLoading(false);
      }
    }
    fetchData();
  }, [sessi.sessionData.token, sessi.ip, sessi.sessionData.id]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const navigate = useNavigate();

  const handleClick = (id) => {
    sessi.setVariable("SolicitudPrestamo", id);
    navigate('/PortalDelParticipante/SolicitudesCarga');
  };

  const handleClickCarga = (id) => {
    sessi.setVariable("SolicitudPrestamo", id);
    navigate(`/PortalDelParticipante/SolicitudesCargaPreAnalisis`);
  };

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearchTerm(searchTerm);
  };

  const handleLoanTypeChange = (event) => {
    setLoanType(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const filteredRows = filas.filter((row) => {
    const status =
      row.aprobado === 1 ? 'Aprobado' :
        row.aprobado === 2 ? 'Aprobado Sujeto A Cambios' :
          row.aprobado === 3 ? 'Rechazado' :
            'Sin Revisar';

    return (
      (row.TipoPrestamo?.includes(loanType) || loanType === '') &&
      (status.includes(statusFilter) || statusFilter === '') &&
      (
        searchTerm === '' ||
        (searchTerm && (
          row.NumeroSolicitud?.toString().includes(searchTerm) ||
          (row.solicitante && row.solicitante[0] && (row.solicitante[0].Nombres?.toLowerCase().includes(searchTerm) || row.solicitante[0].Apellidos?.toLowerCase().includes(searchTerm)))
        ))
      )
    );
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState('');

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType('');
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="container" style={{ marginTop: 10 }}>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <style>{actionButtonsCSS}</style>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2><b>Lista de Solicitudes</b></h2>
          </div>
          <div className="row" style={{ marginTop: '20px' }}>
            <TableContainer component={Paper}>
              <Table style={{ fontSize: isMobile ? '7px' : '14px' }}>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>#</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <strong>No. Solicitud</strong>
                        <Tooltip title="Buscar por Solicitud" arrow>
                          <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                            <ManageSearchIcon style={{ color: 'white' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <strong>Nombre del Solicitante</strong>
                        <Tooltip title="Buscar por Nombre" arrow>
                          <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                            <ManageSearchIcon style={{ color: 'white' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <strong>Tipo De Préstamo</strong>
                        <Tooltip title="Filtrar por Tipo" arrow>
                          <IconButton onClick={(event) => handleFilterClick(event, 'loanType')}>
                            <FilterListIcon style={{ color: 'white' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <strong>Fecha Solicitud</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <strong>Etapa</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <strong>Estado</strong>
                        <Tooltip title="Filtrar por Estado" arrow>
                          <IconButton onClick={(event) => handleFilterClick(event, 'status')}>
                            <FilterListIcon style={{ color: 'white' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                      <strong>Acciones</strong>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleFilterClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                >
                  {filterType === 'search' && (
                    <TextField
                      placeholder="Realizar Búsqueda"
                      aria-label="Search"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  {filterType === 'loanType' && (
                    <FormControl>
                      <Select
                        value={loanType}
                        onChange={handleLoanTypeChange}
                        displayEmpty
                      >
                        <MenuItem value=""><em>Todos los tipos</em></MenuItem>
                        <MenuItem value="Sin Aval">Sin Aval</MenuItem>
                        <MenuItem value="Con Aval">Con Aval</MenuItem>
                        <MenuItem value="Consolidacion de Deuda">Consolidacion de Deuda</MenuItem>
                        <MenuItem value="Alivio de Deuda">Alivio de Deuda</MenuItem>
                        <MenuItem value="Refinanciamiento">Refinanciamiento</MenuItem>
                        <MenuItem value="Hipotecario">Hipotecario</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  {filterType === 'status' && (
                    <FormControl>
                      <Select
                        value={statusFilter}
                        onChange={handleStatusChange}
                        displayEmpty
                      >
                        <MenuItem value=""><em>Todos</em></MenuItem>
                        <MenuItem value="Sin Revisar">Sin Revisar</MenuItem>
                        <MenuItem value="Aprobado">Aprobado</MenuItem>
                        <MenuItem value="Rechazado">Rechazado</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Popover>
                <TableBody>
                  {filteredRows.length > 0 ? (
                    (rowsPerPage > 0
                      ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredRows
                    ).map((row) => (
                      <StyledTableRow key={row.SolicitudID}>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                          {row.SolicitudID !== null && row.SolicitudID !== undefined && row.SolicitudID}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                          {row.NumeroSolicitud !== null && row.NumeroSolicitud !== undefined && row.NumeroSolicitud}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                          {row.solicitante && row.solicitante[0] && row.solicitante[0].Nombres && row.solicitante[0].Apellidos && `${row.solicitante[0].Nombres} ${row.solicitante[0].Apellidos}`}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                          {row.TipoPrestamo !== null && row.TipoPrestamo !== undefined && row.TipoPrestamo}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                          {row.FechaSolicitud !== null && row.FechaSolicitud !== undefined && row.FechaSolicitud.slice(0, 10)}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>
                          {row.aprobado <= 3 ? 'Preanálisis' : 'Solicitud Formal'}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                          {row.aprobado === 1 ? 'Pre Aprobado' : row.aprobado === 2 ? 'Pre Aprobado Sujeto A Cambios' : row.aprobado === 3 ? 'Rechazado' : row.aprobado === 5 ? 'Aprobado' : row.aprobado === 6 ? 'Rechazado' : row.aprobado === 7 ? 'Aprobado Sujeto A Cambios' : 'Sin Revisar'}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                          <div className="action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                            <Link onClick={() => handleClickCarga(row.SolicitudID)} title="Ver Solicitud de Preanálisis" style={{ color: '#10ab80', margin: '0 1px' }}>
                              <i className="material-icons">&#xE417;</i>
                            </Link>

                            {/*(row.aprobado >= 4) && (
                              <Link onClick={() => handleClick(row.SolicitudID)}  title="Ver Solicitud Completa" style={{ color: '#10ab80', margin: '0 1px' }}>
                                  <i className="material-icons">&#xe85d;</i>
                              </Link>
                            )*/}
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={8} style={{ textAlign: 'center', fontSize: isMobile ? '7px' : '14px' }}>
                        No se encontraron datos
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {filteredRows.length > 0 && (
              <TablePagination
                rowsPerPageOptions={isMobile ? [3, 5, 10] : [5, 10, 20]}
                component="div"
                count={filas.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={isMobile ? "Filas:" : "Filas por página"}
                labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count}`}
              />
            )}
          </div>
        </>
      )}

    </div>
  );
}

export default EmpleadosDash;
